import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import { AddButton } from 'components/_basic/Form/FieldArray/components/AddButton';
import { RemoveButton } from 'components/_basic/Form/FieldArray/components/RemoveButton';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';

import { IEachUnitFieldsListProps } from './types';
import { MAX_FIELD_LENGTH } from '../../utils/form';
import { EachUnitFields } from '../EachUnitFields/EachUnitFields';

import styles from './EachUnitFieldsList.module.scss';

export const EachUnitFieldsList: FC<IEachUnitFieldsListProps> = ({
  fields,
  disabled = false,
  name,
  onAddRow,
  onRemoveRow,
}) => {
  const { t } = useTranslation();

  const canAddMore = fields.length < MAX_FIELD_LENGTH;
  const canRemove = fields.length > 1;

  return (
    <FormSectionCard
      collapsible
      disabled={disabled}
      title={t('financialPlan.plannedExpenses.costOfEachUnit.description')}
    >
      <>
        <Box>
          {fields.map((field, index) => (
            <Box key={field.id} className={styles.rowContainer}>
              <Box className={styles.rowChildren}>
                <EachUnitFields
                  name={`${name}.${index}`}
                  disabled={disabled}
                />
              </Box>
              <RemoveButton canRemove={canRemove} disabled={disabled} onClick={() => onRemoveRow(index)} />
            </Box>
          ))}
        </Box>
        <AddButton canAddMore={canAddMore} onClick={onAddRow} disabled={disabled} variant="text">
          {t('global.products.buttonText')}
        </AddButton>
      </>
    </FormSectionCard>
  );
};
